module.exports = __webpack_public_path__ + "img/check-circle.45d4430c.svg";